import { render, staticRenderFns } from "./leaderBoardViewport.vue?vue&type=template&id=5060058f&"
import script from "./leaderBoardViewport.vue?vue&type=script&lang=js&"
export * from "./leaderBoardViewport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports